import Vue from 'vue'

const state = {
  visible: false
}

const getters = {
  visible: state => state.visible,
  activeMenuItem: state => state.activeMenuItem,
  activeChapter: state => state.activeChapter
}

const actions = {
  toggleNavigation ({ commit }, payload) {
    commit(`TOGGLE_NAVIGATION`, payload)
  },

  setActiveMenuItem ({ commit }, payload) {
    commit(`SAVE_ACTIVE_MENU_ITEM`, payload)
  },

  setActiveChapter ({ commit }, payload) {
    commit('SAVE_ACTIVE_CHAPTER', payload)
  }
}

const mutations = {
  TOGGLE_NAVIGATION (state, payload) {
    state.visible = payload || payload === false ? payload : !state.visible
  },

  SAVE_ACTIVE_MENU_ITEM (state, payload) {
    Vue.set(state, `activeMenuItem`, payload)
  },

  SAVE_ACTIVE_CHAPTER (state, payload) {
    Vue.set(state, `activeChapter`, payload)
  }
}

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
